import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-not-found-screen',
  templateUrl: './not-found-screen.component.html',
  styleUrls: ['./not-found-screen.component.scss']
})
export class NotFoundScreenComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
